export const STANDARD_METADATA_FIELDS = [
    {key: "url", label: "URL", value_type: "text"},
    {key: "credit_line", label: "Credit Line", value_type: "text"},
    {key: "person", label: "Person", value_type: "tag", multi: true},
    {key: "event_shown", label: "Event Shown", value_type: "text"},
    {key: "event_identifier", label: "Event Identifier", value_type: "text", multi: true},
    {key: "product", label: "Product", value_type: "tag", multi: true},
    {key: "artwork", label: "Artwork", value_type: "text"},
    {key: "keywords", label: "Keywords", value_type: "tag", multi: true},
    {key: "date_created", label: "Date Created", value_type: "date"},
    {key: "creator", label: "Creator", value_type: "text", multi: true},
    {key: "description", label: "Description", value_type: "text"},
    {key: "headline", label: "Headline", value_type: "text"},
    {key: "byline", label: "Byline", value_type: "text"},
    {key: "special_instructions", label: "Special Instructions", value_type: "text"},
    {key: "title", label: "Title", value_type: "text"},
    {key: "alt_text", label: "Alt Text", value_type: "text"},
    {key: "country", label: "Country", value_type: "text"},
    {key: "state", label: "State", value_type: "text"},
    {key: "city", label: "City", value_type: "text"},
    {key: "sublocation", label: "Sublocation", value_type: "text"}
];

export const STANDARD_METADATA_FIELD_OPTIONS = STANDARD_METADATA_FIELDS.map(field => ({
    value: field.key,
    label: field.label
}));

export const standardTagSubType = key => ({person: 'person', keywords: 'keyword', product: 'product'})[key];

export function standardMetadataFieldLabel(key) {
    return STANDARD_METADATA_FIELDS.find(field => field.key === key)?.label || key;
}

export function standardMetadataFieldsForKeys(keys) {
    const selected = new Set(keys || []);
    return STANDARD_METADATA_FIELDS.filter(field => selected.has(field.key));
}
